import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import Currency from 'components/currency';
import { useLoyaltyContext } from 'state/loyalty';
import { useOrderContext } from 'state/order';
import { priceForCartEntry } from 'utils/menu/price';

import { PriceAndQuantity } from '../cart-item/price-and-quantity';
import { RedeemReward } from '../cart-item/redeem-reward';

import CartPreviewActions, {
  CartPreviewEditButton,
  CartPreviewIncrementor,
  CartPreviewRemoveButton,
  CartPreviewTitle,
  CartPreviewVisuallyHidden,
} from './cart-preview-actions';
import { CartPreviewEditContainer } from './styled/cart-preview-edit-container';
import { CartPreviewEntryContainer } from './styled/cart-preview-entry-container';
import { CartPreviewItem } from './styled/cart-preview-item';
import { ItemPrice } from './styled/item-price';
import { ICartPreviewEntry } from './types';
import { getIsOffer } from './utils';

const PeopleLabel = styled.span`
  color: ${Styles.color.grey.one};
  margin-right: 1rem;
`;

const RedeemRewardWrapper = styled.div`
  > div {
    margin: 1.25rem 0;
  }
`;

const CartPreviewEntry: React.FC<ICartPreviewEntry> = ({
  item,
  selectedOfferCartEntry,
  selectedOfferPrice,
  rewardApplied = false,
}) => {
  const { formatMessage } = useIntl();
  const { isCartEntryInSwaps } = useOrderContext();
  const { loyaltyEnabled, getAvailableRewardFromCartEntry } = useLoyaltyContext();
  const isStandardOffer = getIsOffer({ selectedOfferCartEntry, item });
  const isSwapOffer = isCartEntryInSwaps(item);
  const itemPrice = isStandardOffer ? selectedOfferPrice : priceForCartEntry(item);
  const loyaltyRewardAvailable = getAvailableRewardFromCartEntry(item);
  const displayPriceWithLoyalty = !isStandardOffer && loyaltyEnabled;
  const displayRedeemReward = !isStandardOffer && loyaltyEnabled;

  return (
    <CartPreviewEntryContainer>
      <CartPreviewItem>
        <CartPreviewTitle item={item} />
        {displayPriceWithLoyalty ? (
          <PriceAndQuantity item={item} rewardApplied={rewardApplied} />
        ) : (
          <ItemPrice>
            <Currency amount={isSwapOffer ? item.price : itemPrice} />
          </ItemPrice>
        )}
      </CartPreviewItem>

      {displayRedeemReward && loyaltyRewardAvailable && (
        <RedeemRewardWrapper>
          <RedeemReward
            isRewardApplied={rewardApplied}
            item={item}
            reward={loyaltyRewardAvailable}
          />
        </RedeemRewardWrapper>
      )}
      <CartPreviewActions isOffer={isStandardOffer || isSwapOffer} item={item}>
        <CartPreviewEditContainer>
          <CartPreviewEditButton />
          <CartPreviewRemoveButton />
        </CartPreviewEditContainer>
        <CartPreviewIncrementor>
          {item.labelAsPerPerson && (
            <PeopleLabel>
              {formatMessage({
                id: 'people',
              })}
              :
            </PeopleLabel>
          )}
        </CartPreviewIncrementor>
        <CartPreviewVisuallyHidden />
      </CartPreviewActions>
    </CartPreviewEntryContainer>
  );
};

export default CartPreviewEntry;
